@for (m of chatMessages; track m.sequence) {
    <div class="message" [class]="m.author">
        <div class="timestamp">{{m.author}} ({{m.timestamp | date: 'yyy-MM-dd \'at\' HH:mm:ss'}})</div>
        <app-markdown-renderer [markdown]="m.message"></app-markdown-renderer>
    </div>
}

<div class="input-area">
    <textarea #userMessageTextArea name="userMessageTextArea" (keydown)="onAutoResize($event)" placeholder="Ask Anything"></textarea>
    <div class="button-group">
        @if (isLoading()) {
            <button class="icon-button" (click)="onInterruptChat()">
                <i class="far fa-stop"></i>
            </button>
        }
        <button class="icon-button" (click)="onSubmitUserMessage()">
            <i class="far fa-arrow-up"></i>
        </button>
    </div>
</div>
